import { Component } from 'Shared/frontend/widgets/Component';
import { StylesProvider, IStyleDetails, useStylePath, useStyleDetails } from 'Shared/frontend/widgets/StylesProvider';
import { siteTheme } from 'Shared/frontend/SettingsProvider';
import { createCssFromSettings } from 'Shared/frontend/widgets/createCssFromSettings';
import { locationMatches } from 'Shared/frontend/widgets/locationMatches';


export function Styles(P: {styles:string[],removeStyles:string[],classes:string[]})
{
	const path = useStylePath();

	const parentStyles = useStyleDetails();

	/* Add new styles. We prepend the current path to their location expressions. */
	const calcStyles = () => {  
		const flatPath = path.map(e => e.key);

		const trimmedParent = parentStyles().filter(e => !(P.removeStyles ?? []).includes(e.tag));
		const styleDetails = resolveStyleDetails(flatPath,P.styles);

		return [...trimmedParent, ...styleDetails] as IStyleDetails[];
	};

	return (
		<StylesProvider path={path} styleDetails={calcStyles}> 
			<Component {...P.content} />
		</StylesProvider>
	);
}

export function resolveNavStyles(styleDetails: IStyleDetails[], atTop: boolean): any
{
	const navPath = [{key: 'nav'}];
	let css = {};
	let settings = {};

	for (const detail of styleDetails) {
		const style = siteTheme().styles[detail.tag];
		if (!style) continue;

		for (const rule of style.rules(atTop) ?? []) {
			const ruleLocExpr = [...detail.pathWhenAdded, ...rule.location];
			if (locationMatches(ruleLocExpr, navPath)) {
				const ruleCss = {...rule.css};
				const ruleSettings = {};
				for (const [fieldName, fieldValue] of Object.entries(rule))
					createCssFromSettings(fieldName, fieldValue, ruleCss, ruleSettings);
				css = {...css, ...ruleCss};
				settings = {...settings, ...ruleSettings};
			}
		}
	}
	delete (settings as any).location;
	return {...settings, css};
}

export function resolveFooterStyles(styleDetails: IStyleDetails[]): any
{
	const footerPath = [{key: 'footer'}];
	let css = {};
	let settings = {};

	for (const detail of styleDetails) {
		for (const rule of detail.rules ?? []) {
			const ruleLocExpr = [...detail.pathWhenAdded, ...rule.location];
			if (locationMatches(ruleLocExpr, footerPath)) {
				css = {...css, ...rule.css};
				settings = {...settings, ...rule.settings};
			}
		}
	}
	delete (settings as any).location;
	return {...settings, css};
}

export function resolveStyleDetails(flatPath,styles):IStyleDetails[]
{
	const styleDetails:IStyleDetails[] = [];

	for (const styleOrTag of styles ?? []) {     //FIXME styleOrTag ==> style

//FIXME MIXED stuff coming through styles... 
//      REQUIRES migration
const t = styleOrTag.type ?? styleOrTag;		

		const style = siteTheme().styles[t];
		if (!style) 
			log.warn(`Style not found: ${t}`)

		const rules = style?.rules(styleOrTag.params) ?? [];

		const resolved = [];

		for (const rule of rules) {
			const css = {...rule.css};
			const settings = {}

			for (const [fieldName,fieldValue] of Object.entries(rule)) 
				createCssFromSettings(fieldName,fieldValue,/*mod*/css,/*mod*/settings);

			resolved.push({location:rule.location,settings,css});  
		}
		//styleDetails.push({tag:tag,pathWhenAdded:flatPath,rules:resolved});  
		styleDetails.push({tag:t,pathWhenAdded:flatPath,rules:resolved});  
	}
	return styleDetails;
}

